import React, { createContext, useCallback } from "react";
import { useAppInsights } from "../services/appInsights";
import { TelemetryEvents } from "../telemetry/eventNames";
import { TelemetryProp, toTelemetryProps } from "../telemetry/telemetryProps";
import { TelemetrySurface } from "../telemetry/surfaces";

const noop = () => {};

type Context = {
  title: string;
  action: React.ReactNode;
  setNewTitle(title: string): void;
  setAction(action: React.ReactNode): void;
};

const PageContext = createContext<Context>({
  title: "",
  action: null,
  setNewTitle: noop,
  setAction: noop,
});

const PageContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { trackEvent } = useAppInsights();
  const [title, setTitle] = React.useState<string>("");
  const [action, setAction] = React.useState<React.ReactNode>(null);

  const handleSetTitle = useCallback(
    (title: string) => {
      setTitle(title);
      trackEvent({
        name: TelemetryEvents.pageChanged,
        properties: toTelemetryProps({
          [TelemetryProp.surface]: TelemetrySurface.page,
          [TelemetryProp.title]: title,
        }),
      });
    },
    [trackEvent]
  );

  return (
    <PageContext.Provider value={{ title, action, setNewTitle: handleSetTitle, setAction }}>
      {children}
    </PageContext.Provider>
  );
};

export { PageContext, PageContextProvider };
